import RandomNumberGenerator from "../../RandomNumberGenerator"
import EquationValue, {
  variables,
  VariableType,
} from "../../../Model/Value/EquationValue"
import NumberValue from "../../../Model/Value/NumberValue"
import ValueGeneratorInterface from "../ValueGeneratorInterface"

export default class SubtractionEquationValueGenerator implements ValueGeneratorInterface {
  constructor(private readonly randomNumberGenerator: RandomNumberGenerator) {}

  public supports(): boolean {
    return true
  }

  public generate(x: number): EquationValue {
    const variable: VariableType = this.randomNumberGenerator.pick(variables)

    if (this.randomNumberGenerator.coin()) {
      // a - x = b
      // x = a - b
      const a: number = this.randomNumberGenerator.randomInt(x + 1, x * 5)
      const b: number = a - x
      return new EquationValue(
        new NumberValue(a),
        new NumberValue(x),
        new NumberValue(b),
        variable,
        "a - x = b",
      )
    }

    // x - a = b
    // x = a + b
    const a: number = this.randomNumberGenerator.randomInt(1, x - 1)
    const b: number = x - a

    return new EquationValue(
      new NumberValue(a),
      new NumberValue(x),
      new NumberValue(b),
      variable,
      "x - a = b",
    )
  }
}
